import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { default as config } from '../../config/channels';
import { TChannel } from '../../contexts/operator/operator-context';
import { getSiteSelectVariant } from '../../services/siteSelectVariant';
import { operatorName } from '../../config/operator';
import useOperatorContext from '../../contexts/operator/useOperatorContext';
import useAppContext from '../../contexts/app/useAppContext';
import PageSpinnerThree from '../general/PageSpinnerThree';
import CheckoutPage from './Checkout/CheckoutPage';
import ConfirmationPage from './Confirmation/ConfirmationPage';
import GroupConfirmationPage from './GroupConfirmation/GroupConfirmationPage';
import MenuPage from './Menu/MenuPage';
import ChannelSelectPage from "./ChannelSelect/ChannelSelectPage";
import ChannelSelectModalPage from "./ChannelSelect/ChannelSelectModalPage";
import TableSelectPage from "./TableSelect/TableSelectPage";

// Where to order from: a page of its own, or a modal over the menu (for some operators, one or the other at random for each visitor)
const LandingPage = ({ channel }: { channel?: TChannel | null }) =>
    getSiteSelectVariant() === 'modal' ? <ChannelSelectModalPage channel={channel} /> : <ChannelSelectPage channel={channel} />;

const SiteRoutes = () => {
    const operatorContext = useOperatorContext();
    const appContext = useAppContext();
    const navigate = useNavigate();

    useEffect(() => {
        if ( operatorContext ) {
            operatorContext.fetchOperator(operatorName);
        } else {
            console.warn('Operator context not fired.');
        }

        if (appContext) {
            appContext.setInitialAssetManifest();
        } else {
            console.warn('App context not fired.');
        }
    }, []);

    if (!operatorContext || !operatorContext.operator) {
        if (!operatorContext.loading) {
            navigate('/500');
        }

        return <PageSpinnerThree show={true} />;
    }

    const renderChannelRoutes = () => {
        let channels = [config.collection, config.delivery, config.dineIn, config.catering, config.venues];
        return channels.map((channel) => {
            return (
                <React.Fragment key={channel.name}>
                    <Route path={`${channel.handle}/*`} element={
                        <LandingPage channel={channel.name} />
                    } />
                    <Route path={`${channel.handle}/:restaurant_id`} element={
                        <MenuPage channel={channel.name} />
                    } />
                    <Route path={`${channel.handle}/:restaurant_id/checkout`} element={
                        <CheckoutPage />
                    } />
                </React.Fragment>
            );
        });
    };

    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />

            <Route path={`/at-table/:restaurant_id/table`} element={<TableSelectPage />} />
            { renderChannelRoutes() }

            <Route path="/menu/:restaurant_id" element={<MenuPage channel={config.collection.name} />} />
            <Route path="/:restaurant_id" element={<MenuPage channel={config.collection.name} />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path={`/confirmation/:ref`} element={<ConfirmationPage />} />
            <Route path="/group-confirmation" element={<GroupConfirmationPage />} />
        </Routes>
    );
};

export default SiteRoutes;
